import { render, staticRenderFns } from "./Expansion.vue?vue&type=template&id=4b613c37&scoped=true"
import script from "./Expansion.vue?vue&type=script&lang=js"
export * from "./Expansion.vue?vue&type=script&lang=js"
import style0 from "./Expansion.vue?vue&type=style&index=0&id=4b613c37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b613c37",
  null
  
)

export default component.exports